// Client V2 common imports
const { getExternalHrefDomain } = require('client-v2/common/state/router/utils')

// Action types

const SHOW_BANNER = 'LOGGED_OUT_HOME_SHOW_BANNER'

// Action creators

function show(url) {
  return {
    type: SHOW_BANNER,
    payload: getExternalHrefDomain(url)
  }
}

module.exports = {
  // Action types
  SHOW_BANNER,
  // Action creators
  show
}
